<template>
  <div class="bgc  chinese_container">
    <div class="register_content">
      <h2>hecoos</h2>
      <p>为保证您能快速通过审核，请填写真实有效的信息</p>

      <div class="input-group">
        <input type="text" placeholder="真实姓名" v-model="form.rname" />
        <input type="email" placeholder="邮箱" v-model="form.email" />
      </div>

      <div class="phone-verify-group">
        <div class="phone-verify-container">
          <input
            type="text"
            placeholder="手机号"
            v-model="form.phone"
            class="phone-input"
          />
          <button
            :disabled="!isPhoneValid || isCountingDown"
            @click="obtainCode"
            class="verify-code-button"
          >
            {{ isCountingDown ? `${countdown}s后重试` : "获取验证码" }}
          </button>
        </div>
        <input
          type="text"
          placeholder="验证码"
          v-model="form.verifyCode"
          autocomplete="new-password"
          class="verify-input"
        />
      </div>

      <div class="input-group">
        <input type="password" placeholder="设置密码" v-model="form.password" />
        <input
          type="password"
          placeholder="确认密码"
          autocomplete="new-password"
          v-model="form.confirmPassword"
        />
      </div>

      <div class="input-group">
        <input type="text" placeholder="所在公司名称" v-model="form.company" />
        <input type="text" placeholder="所在城市" v-model="form.city" />
      </div>

      <div class="input-group">
        <input type="text" placeholder="职位" v-model="form.position" />
<!--        <input type="text" placeholder="从业时间" v-model="form.workDuration" />-->

        <select  placeholder="从业时间" :class="{'none_select' : !form.workDuration}" v-model="form.workDuration">
          <option value="" disabled selected>从业时间</option>
          <option v-for="item in workDurationList" :value="item.name">{{item.name}}</option>
        </select>
      </div>
      <div class="input-group">
        <input type="text" placeholder="推荐人(非必填)" v-model="form.referrer" />
      </div>

      <button :disabled="!isButtonEnabled" @click="goRegister">下一步</button>
      <div class="link-container">
        <span @click="jumpTo('/')">回首页</span>
        <span> | </span>
        <span @click="jumpTo('/login')">已有账户? 登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaptcha, adminRegister } from "@/api/api";
import { Message } from "element-ui";
export default {
  data() {
    return {
      form: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
        referrer:""
      },
      isCountingDown: false,
      countdown: 60,
      errorMessages: [], // 新增：收集所有错误信息
      workDurationList:[
        {name:'1年'},
        {name:'2年'},
        {name:'3年'},
        {name:'4年'},
        {name:'5年'},
        {name:'6年'},
        {name:'7年'},
        {name:'8年'},
        {name:'9年'},
        {name:'10年以上'}
      ]
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.phone &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(this.form.phone);
    },
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url);
    },
    // 中文姓名校验
    checkRname(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 邮箱校验
    isEmailValid(str) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(str);
    },

    // 验证码校验（6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },

    // 公司名称校验（至少2个汉字）
    checkCompany(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 城市校验（中文）
    checkCity(str) {
      let reg = /^[\u4e00-\u9fa5]+$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },

    // 工作年限校验（数字或数字+年）
    checkWorkDuration(str) {
      let reg = /^\d+(\s*年)?$/;
      return reg.test(str);
    },
    obtainCode() {
      // 先校验手机号格式
      if (!this.isPhoneValid) {
        Message.error("请输入正确的手机号格式");
        return;
      }

      let postData = {
        phone: this.form.phone,
      };
      getCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },
//注册
    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }
      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/login");
        } else {
          Message.error(res.message || "注册失败，请重试");
        }
      });
    },

    validateForm() {
      const errors = [];

      // 收集所有错误
      if (!this.checkRname(this.form.rname))
        errors.push("请输入中文姓名（至少2个字符）");
      if (!this.isPhoneValid) errors.push("手机号格式不正确，请重新输入");
      if (!this.isEmailValid(this.form.email))
        errors.push("邮箱格式不正确，请重新输入");
      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("请输入6位数字的验证码");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("密码长度至少为6位");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("两次输入的密码不一致");
      if (!this.checkCompany(this.form.company))
        errors.push("请输入正确的公司名称（至少2个汉字）");
      if (!this.checkCity(this.form.city)) errors.push("请输入中文城市名称");
      if (!this.checkPosition(this.form.position))
        errors.push("请输入职位（至少2个字符）");
      if (!this.checkWorkDuration(this.form.workDuration))
        errors.push("请选择正确的从业时间（如：1年、3）");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/optimize_adaptation.scss";
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.register_content {
  background-color: #222;
  width: 650px;
  padding: 30px 50px;
  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 30px;
  font-size: 20px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.input-group input,
.input-group select,
.phone-verify-group input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
}
.input-group select.none_select {
  color: #757575;
}
.input-group select:focus-visible{
  border: none;
  outline: none;
}
.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  font-size: 18px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  width: 100%;
  height: auto;
}

.verify-code-button {
  width: 120px;
  padding: 14px 10px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 18px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  height: auto;
  font-size: 18px;
}

button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 18px;
  transition: all 0.3s;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
</style>
